import { existingEmailApi } from './existingEmailApi';

export const { useEmailExistsMutation } = existingEmailApi;

export { existingEmailApi };
